import { makeActionFactory } from './actionFactory';
import { UtcTime, DeviceIndex, DeviceId } from 'types';

export type ActionType =
    'INIT_SUCCESS'
    | 'INIT_FAILURE'
    | 'LANGUAGE_LOAD_FAILURE'
    | 'UNHANDLED_ERROR'
    | 'SET_CAMERA_AND_TIME'
    | 'SET_REQUESTED_VIEW'
;

const actionFactory = makeActionFactory<ActionType>();


//
//  INIT_SUCCESS action notifies the app that all initialization steps succeeded
//  (i.e. now it's safe to switch from the loading screen to the app)
//
export interface InitializationSuccessAction {
    type: 'INIT_SUCCESS';
}
export const initializationSuccess = actionFactory.empty<InitializationSuccessAction>('INIT_SUCCESS');


//
//  INIT_FAILURE action notifies the app that at least one initialization steps failed
//  (i.e. We cannot show the app. This is a fatal condition)
//
export interface InitializationFailureAction {
    type: 'INIT_FAILURE';
    payload: Error;
    error: true;
}
export const initializationFailure = actionFactory.error<InitializationFailureAction>('INIT_FAILURE');


//
//  LANGUAGE_LOAD_FAILURE action notifies the app that translation text failed to load
//  (i.e. we're in trouble... can't show the app)
//
export interface LanguageLoadFailureAction {
    type: 'LANGUAGE_LOAD_FAILURE';
    payload: Error;
    error: true;
    meta: {
        languageCode: string;
    };
}
export const languageLoadFailure = actionFactory.errorMeta<LanguageLoadFailureAction, { languageCode: string }>('LANGUAGE_LOAD_FAILURE');


//
//  UNHANDLED_ERROR action notifies the app that an unhandled error occurred
//
export interface UnhandledErrorAction {
    type: 'UNHANDLED_ERROR';
    payload: {
        msg: string;
        url: string;
        line: number;
        col: number;
        error: Error;
    };
}
export const unhandledError = actionFactory.payload<UnhandledErrorAction, UnhandledErrorAction['payload']>('UNHANDLED_ERROR');


//
//  SET_CAMERA_AND_TIME action stores the 'cam' and 't' query parameters that come from the Web Client URL in
//  alarm emails. We need to store them because the router code can rewrite the URL, which causes the query
//  parameters to be discarded.
//
export interface SetCameraAndTimeAction {
    type: 'SET_CAMERA_AND_TIME';
    payload: {
        deviceIndex: DeviceIndex;
        utcTime: UtcTime;
    } | {
        deviceId: DeviceId;
        utcTime: UtcTime;
    };
}
export const setCameraAndTime = actionFactory.payload<SetCameraAndTimeAction, SetCameraAndTimeAction['payload']>('SET_CAMERA_AND_TIME');


//
//  SET_REQUESTED_VIEW action stores the 'view' query parameter that comes from ServerConfig.
//  We need to store it because the router code can rewrite the URL, which causes the query
//  parameters to be discarded.
//
export interface SetRequestedViewAction {
    type: 'SET_REQUESTED_VIEW';
    payload: DeviceIndex[];
}
export const setRequestedView = actionFactory.payload<SetRequestedViewAction, SetRequestedViewAction['payload']>('SET_REQUESTED_VIEW');



// WEBPACK FOOTER //
// ./src/actions/appActions.ts